/**
 * Guest competitor utilities — synthetic ID generation and guest detection.
 */

/**
 * Generate a unique guest competitor ID.
 * Format: guest_{timestamp}_{random4hex}
 */
export const generateGuestId = () => {
  const timestamp = Date.now();
  const random = Math.random().toString(16).slice(2, 6);
  return `guest_${timestamp}_${random}`;
};

/**
 * Check if a UID belongs to a guest competitor.
 */
export const isGuestCompetitor = (uid) => {
  return typeof uid === 'string' && uid.startsWith('guest_');
};
